<template>
  <div class="beneficiary-card display-flex align-items-center justify-content-space-between" :class="isDisplayAsCard ? 'card card-20' : '' ">
    <div v-if="!isQuickSend" class="col-bank">
      <img :src="getBankImg(this.bankId)"/>
    </div>
    <div :class=" (isQuickSend) ? 'col-details' : '' ">
      <div class="wandr-level-3">{{(this.beneficiaryAlias == '' || this.beneficiaryAlias == null) ? this.beneficiaryFirstName : this.beneficiaryAlias}}</div>
      <div class="wandr-caption-2" v-if="this.deliveryMethodId == 1 || this.deliveryMethodId == 6 || this.deliveryMethodId == 9">{{this.bankName}}({{this.bankAccountNo}})</div>
      <div class="wandr-caption-2" v-if="this.deliveryMethodId == 3">{{this.collectionAgent}}</div>
      <div class="wandr-caption-2" v-if="this.deliveryMethodId == 4">{{this.province}}&nbsp;&bull;&nbsp;{{this.city}}</div>
      <div class="wandr-caption-2" v-if="this.deliveryMethodId == 0">{{this.billingOrg}}&nbsp;&bull;&nbsp;{{this.bankAccountNo}}</div>
    </div>
    <div :class=" (isQuickSend) ? 'col-bank' : 'col-country' ">
      <img :src="(isQuickSend) ? getBankImg(this.bankId) : getCircleSmallFlagImg(this.homeCountryId)"/>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isQuickSend:{
        required: false
      },
      isDisplayAsCard:{
        required: false
      }
    },
    mounted() {
      this.bankAccountNo        = this.$store.state.transaction.bankAccountNo
      this.bankId               = this.$store.state.transaction.bankId
      this.bankName             = this.$store.state.transaction.bankName
      this.beneficiaryAlias     = this.$store.state.transaction.beneficiaryAlias
      this.beneficiaryFirstName = this.$store.state.transaction.beneficiaryFirstName
      this.billingOrg           = this.$store.state.transaction.billingOrg
      this.city                 = this.$store.state.transaction.city
      this.collectionAgent      = this.$store.state.transaction.collectionAgent
      this.deliveryMethodId     = this.$store.state.transaction.deliveryMethodId
      this.homeCountryId        = this.$store.state.transaction.homeCountryId
      this.province             = this.$store.state.transaction.province
    },
    data: function () {
      return {
        bankAccountNo       : "",
        bankId              : 0,
        bankName            : "",
        beneficiaryAlias    : "",
        beneficiaryFirstName: "",
        billingOrg          : "",
        city                : "",
        collectionAgent     : "",
        deliveryMethodId    : 0,
        homeCountryId       : 0,
        province            : "",
      }
    }
  }
</script>